import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { REDIRECT_PARAM } from 'constants/config';

export default ({ component: C, props: cProps, ...rest }) => {
  const redirectObject = new URLSearchParams(rest.location.search);
  const redirectTo = redirectObject.get(REDIRECT_PARAM) || '';
  return (<Route
    {...rest}
    render={props => (!cProps.isAuthenticated ?
      <C {...props} {...cProps} /> : <Redirect to={redirectTo} />
    )}
  />);
};
